import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  IoMdCheckmarkCircleOutline,
  IoMdCloseCircleOutline,
} from "react-icons/io";
import {} from "react-icons/io";
import { useLanguageContext } from "../../Context/LanguageContext";
import Logo from "../Logo/Logo";
import { CiImageOn } from "react-icons/ci";

const QuestionResponseTable = ({ inspectionItems }) => {
  const { localization } = useLanguageContext();
  return (
    <TableContainer component={Paper} className="mt-2 question-response-table">
      <Table className="custom-table">
        {/* ---------every table header -------- */}

        <TableHead>
          <TableRow>
            <TableCell
              className="table-cell no-border-right "
              sx={{ width: "60%" }}
            >
              <strong>{localization.frage}</strong>
            </TableCell>
            <TableCell
              className="table-cell no-border-right text-left "
              sx={{ width: "30%" }}
            >
              <strong>{localization.antwort}</strong>
            </TableCell>
            <TableCell
              className="table-cell no-border-right text-left "
              sx={{ width: "10%" }}
            >
              <strong>{localization.image || "Image"}</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        {/* ------------reusable header ---------- */}
        <TableBody>
          {inspectionItems.map((question, index) => (
            <TableRow key={index} className="question-row">
              <TableCell className="table-cell no-vertical-border">
                {question.frage}
              </TableCell>
              <TableCell className="table-cell no-vertical-border">
                {question.antwort}
              </TableCell>
              <TableCell className="table-cell no-vertical-border"></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const InspectionReportPreview = ({
  open,
  onClose,
  selectedAttributes = [],
}) => {
  const { localization } = useLanguageContext();
  const [checklistData, setChecklistData] = useState([]);
  const [inspectionImage, setInspectionImage] = useState([]);
  const [imagesSrc, setImagesSrc] = useState([]);
  const [feedBack, setFeedback] = useState(localization.dummyFeedback);

  useEffect(() => {
    setChecklistData([
      {
        title: localization.dummyChapter,
        checklistBlockModels: [
          {
            title: localization.dummyBlock,
            description: "",
            pruefFragenItemModels: [],
            answers: [
              {
                frage: localization.dummyQuestion1,
                antwort: "J",
              },
              {
                frage: localization.dummyQuestion2,
                antwort: "J",
              },
              {
                frage: localization.dummyQuestion3,
                antwort: "J",
              },
              {
                frage: localization.dummyQuestion4,
                antwort: "J",
              },
            ],
            files: [],
          },
        ],
      },
    ]);

    return () => {};
  }, []);

  const getFormattedDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  };

  const currentDate = new Date();
  const nextYearDate = new Date(currentDate);
  nextYearDate.setFullYear(currentDate.getFullYear() + 1);

  const inspectionDetails = {
    checklistTitle: localization.dummyChecklistTitle,
    pruefer: localization.dummyInspector,
    frequency: localization.monthly,
    endDate: getFormattedDate(currentDate),
    nio: "false",
    nextCheckDate: getFormattedDate(nextYearDate),
  };

  useEffect(() => {
    let image = [];
    if (inspectionImage.length > 0) {
      inspectionImage.map((item) => {
        image.push({ url: `data:image/jpg;base64,${item.documentAsString}` });
      });
      setImagesSrc(image);
    }
  }, [inspectionImage]);

  const renderSelectedAttributes = () => {
    const midIndex = Math.ceil(selectedAttributes.length / 2);
    const leftAttributes = selectedAttributes.slice(0, midIndex);
    const rightAttributes = selectedAttributes.slice(midIndex);

    const renderAttribute = (attribute, index) => (
      <div className="d-flex justify-content-between mb-2" key={index}>
        <Typography variant="body1" color="text.secondary" fontSize="medium">
          {attribute.nameDisplay}:
        </Typography>
        <strong>
          {localization.value}
          {index + 1}
        </strong>
      </div>
    );

    return (
      <div className="equipment-attributes-section p-3">
        <Typography variant="h5">{localization.equipmentAttributes}</Typography>
        <div className="row">
          <div className="col-md-6 d-flex flex-column">
            {leftAttributes.map((attr, index) => renderAttribute(attr, index))}
          </div>
          <div className="col-md-6 d-flex flex-column">
            {rightAttributes.map((attr, index) =>
              renderAttribute(attr, midIndex + index)
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="md"
        className="inspection-dialog"
      >
        <DialogTitle>
          <div className="d-flex justify-content-between align-items-center">
            <Typography variant="h4">
              {localization.inspectionReport} - #{localization.dummyInventoryId}
            </Typography>
            <Logo />
          </div>
          <Typography
            variant="body1"
            className="mt-2"
            color="text.secondary"
            fontSize="small"
          >
            {localization.inspectionFrom} {inspectionDetails?.endDate}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h5" className="d-flex inspectionStatusTitle">
            {inspectionDetails?.nio.toLowerCase() == "true" ? (
              <IoMdCloseCircleOutline className="mr-1" size={22} color="red" />
            ) : (
              <IoMdCheckmarkCircleOutline
                className="mr-1"
                size={22}
                color="green"
              />
            )}
            {inspectionDetails?.nio.toLowerCase() == "true"
              ? localization.failedInspection
              : localization.passedInspection}
          </Typography>
          <Typography
            variant="body1"
            className="mt-2"
            color="text.secondary"
            fontSize="small"
          >
            {localization.conductedOn} {inspectionDetails?.endDate}{" "}
            {localization.by} {inspectionDetails?.pruefer}
          </Typography>

          <div className="inspection-checklist-container pl-0 pr-0">
            <div className="checklist-info">
              <Typography variant="h5">{localization.checklistInfo}</Typography>
              <div>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontSize="medium"
                >
                  {localization.name}:
                </Typography>
                <strong>{inspectionDetails?.checklistTitle}</strong>
              </div>
              <div>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontSize="medium"
                >
                  {localization.zyklusLabel}:
                </Typography>
                <strong>{inspectionDetails?.frequency}</strong>
              </div>
              <div>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontSize="medium"
                >
                  {localization.nextCheckDate}:
                </Typography>
                <strong>{inspectionDetails?.nextCheckDate}</strong>
              </div>
            </div>
            <div className="inspection-details">
              <Typography variant="h5">
                {localization.inspectionDetails}
              </Typography>
              <div>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontSize="medium"
                >
                  {localization.date}:
                </Typography>
                <strong>{inspectionDetails?.endDate}</strong>
              </div>
              <div>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontSize="medium"
                >
                  {localization.prueferLabel}:
                </Typography>
                <strong>{inspectionDetails?.pruefer}</strong>
              </div>
              <div>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontSize="medium"
                >
                  {localization.status}:
                </Typography>
                <strong>
                  {inspectionDetails?.nio.toLowerCase() == "true" ? (
                    <IoMdCloseCircleOutline
                      className="mr-1"
                      size={20}
                      color="red"
                    />
                  ) : (
                    <IoMdCheckmarkCircleOutline
                      className="mr-1"
                      size={20}
                      color="green"
                    />
                  )}
                  {inspectionDetails?.nio.toLowerCase() == "true"
                    ? localization.failed
                    : localization.passed}
                </strong>
              </div>
            </div>
          </div>
          {selectedAttributes.length > 0 && renderSelectedAttributes()}

          <Typography variant="h6" className="mt-3">
            {localization.inspectionQuestions}
          </Typography>

          {checklistData &&
            checklistData.map((chapter, chapterIndex) => {
              return (
                <>
                  <Typography variant="body2" className="mt-4">
                    {chapter.title}
                  </Typography>
                  {chapter.checklistBlockModels.map((block, blockIndex) => {
                    return (
                      <>
                        <Typography variant="body2" className="mt-4">
                          {block.title}
                        </Typography>
                        <QuestionResponseTable
                          inspectionItems={block.answers}
                        />
                      </>
                    );
                  })}
                </>
              );
            })}
          <br></br>

          <Typography variant="h6" className="mt-3">
            {localization.inspectionImages}
          </Typography>
          <Typography
            className="mt-4 pl-5 pr-4 text-justify mb-5"
            variant="body2"
          >
            <div className="row ml-0 mt-2">
              <CiImageOn size={300} />
            </div>
          </Typography>
          {/* -------------Notes------------ */}
          <Typography variant="h6" className="mt-5">
            {localization.notes}
          </Typography>
          <Typography
            className="mt-4 pl-5 pr-4 text-justify mb-5"
            variant="body2"
          >
            {feedBack}
          </Typography>
        </DialogContent>

        {/* ------------footer button -------------- */}
        <DialogActions>
          <Button
            onClick={onClose}
            variant="outlined"
            size="large"
            sx={{ textTransform: "none" }}
          >
            {localization.close}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InspectionReportPreview;
